// TODO: use generated schema types.
export default function isRejected(status: any) {
  return status === "REJECTED";
}
